export default "__VITE_ASSET__CxMRd9A2__"